/**
 * Utility to filter out test practitioners on production.
 *
 * On the production hostname (mynirva.com) the emails listed below are
 * excluded from every practitioner list so that test accounts are never
 * shown to real users.  On staging / local environments the list is
 * returned unchanged.
 */

const TEST_PRACTITIONER_EMAILS = [
  'djames012@yahoo.com',
  'sarah.miller.test@mynirva.com',
];

export const isProduction = () =>
  window.location.hostname === 'mynirva.com';

/**
 * Remove test practitioners when running on production.
 * @param {Array} practitioners – array of practitioner objects (must have an `email` field)
 * @returns {Array} filtered array
 */
export const filterTestPractitioners = (practitioners) => {
  if (!isProduction()) return practitioners;
  if (!Array.isArray(practitioners)) return practitioners;

  return practitioners.filter(
    (p) => !TEST_PRACTITIONER_EMAILS.includes(p.email?.toLowerCase())
  );
};
